/**
 * @description 获取首页配置
 * @author Kody
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IndexModuleType, IProgramCourse, IHomePageRes, ICourseHomePage, IResponse } from '@umu/umu-types';

export interface IHomePageInfoParam {
    enterprise_id: number;
    type: IndexModuleType;
    id?: string;
    size?: number;
    page?: number;
    program_id?: number;
}

export type courseRes = IHomePageRes<ICourseHomePage>;
export interface IProgramRes {
    share_url: string;
    page_info: IPageInfo;
    list: IProgramCourse[];
    portalconfig_id: string;
    module_num: number;
    group_num: number;
    session_num: number;
    open_module: number;
}

export function getHomePageInfo<T>(data: IHomePageInfoParam): Promise<IResponse<T>> {
    return fetchData(Api.GET_HOME_PAGE_INFO, data).then((res: IResponse<T>) => {
        return res;
    });
}
